import 'regenerator-runtime/runtime';
import './assets/scss/resources.scss';

import { header } from './building-blocks/header/header.module';
import { filter } from './building-blocks/filter/filter.module';
import {newsArchive} from "./building-blocks/news-archive/news-archive.module";
/**
 * Initializes all components on the current page and optionally listens for changes in the DOM to initialize
 * dynamically created objects later on.
 * @param observe Boolean if all components should listen for changes in the DOM and initialize dynamically added
 *   components
 */
const initializeAllComponentsResources = (observe): void => {
    newsArchive.initializeAll(observe);
    header.initializeAll(observe);
    filter.initializeAll(observe);
};

/**
 * Waits for document content loaded event and initializes all javascript controls.
 */
document.addEventListener('DOMContentLoaded', () => {
    if (!document.body.getAttribute('data-news-initialized')) {
        initializeAllComponentsResources(true);
        document.body.setAttribute('data-news-initialized', 'true');
    }
});
